import React from "react"
import { Filter, FilterComponent, FilterExtraAction } from "../../components/_WMS/FilterComponent"
import { filterOptions } from "./config"

export interface FilterOption {
    order: number
    key: string
    label: string
    type: 'numeric' | 'text' | 'range' | 'precreated' | 'custom' | 'date'
    options?: []
    Component?: React.ComponentType<ComponentProps> // Solo para 'custom'
    // Otras propiedades que puedas necesitar para tipos específicos
  }

  interface ComponentProps {}
  interface ProductSearchProps {
    onSearchClick: (filters: Filter[]) => void
    selectedFilters: Filter[]
    setSelectedFilters: any
    includeAddButton?: boolean
    extraActions?: FilterExtraAction[]
  }
  
  export const ProductSearch: React.FC<ProductSearchProps> = (
    props
  ) => {
    return <FilterComponent includeRefreshSearch={true} includeSearchOnClean={true} options={filterOptions} {...props} />
  }